import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './layouts/login/login.component';
import { SigninComponent } from './signin/signin.component';

const routes: Routes = [
  {

    path: "", component: DashboardComponent, canActivate: [AuthGuard], children: [
      {
        path: "calendar", component: HomeComponent, data: { module: "Calendario", accion: "Visual" }
      }
    ]
  }, 
  {
    path: "login", component: LoginComponent, children: [
      {
        path: "", component: SigninComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComponentRoutingModule { }
